import axios from "axios";

const api = axios.create({
  baseURL: "https://api-core-comunicacao-git-631554619185.europe-west1.run.app/api", 
  timeout: 30000,
});

// Se você usa token no redux/localStorage:
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const freightApi = {
  create: (payload) => api.post("/freight/save", payload),        // POST create
  update: (id, payload) => api.patch(`/freight/update/${id}?isFinalize=false`, payload), // PUT update (ou PATCH)
};

export default freightApi;
